var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598.639,
    height: 598.639,
    viewBox: "0 0 158.39 158.39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M173.11 154.3a.195.195 0 0 0-.191.2c0 28.338-16.585 53.102-41.22 67.11-24.635 14.007-53.524 15.1-77.877.608-.229-.152-.442.208-.2.336a79.191 79.191 0 0 0 119.688-68.055.196.196 0 0 0-.199-.2z",
    color: "#000",
    fill: "#ff3d53",
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      paintOrder: "fill markers stroke",
      shapePadding: 0,
      textDecorationColor: "#000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    },
    transform: "translate(-14.924 -75.31)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loading_circle.6996c815dbbb3da005c83f42835d3baa.svg";
export { ForwardRef as ReactComponent };